module.exports = __webpack_public_path__ + "img/Briefings.733ea30e.svg";